import { Pipeline } from '../external-data/types';

export interface FilterProps {
  attributeName: string;
  filter: unknown;
}

const filterWithMultipleFilters = (value: string, filters: string[]): boolean =>
  filters.some((entry) => entry === value);

export const FilterService = {
  filterByAttribute(
    data: Pipeline[],
    filter: FilterProps,
    splitFilterAt = '', // if left empty, it wont split
  ): Pipeline[] {
    return data.filter((entry) => {
      if (!filter.filter) {
        return true;
      }

      const targetAttribute = entry[filter.attributeName];
      if (!splitFilterAt) {
        return targetAttribute === filter.filter;
      }
      const filterValues = (filter.filter as string)?.split(splitFilterAt);
      return filterWithMultipleFilters(targetAttribute, filterValues);
    });
  },

  filterByAttributes(data: Pipeline[], filters: FilterProps[], splitFilterAt = ''): unknown[] {
    let filteredData = data;

    filters.forEach((filter) => {
      filteredData = this.filterByAttribute(filteredData, filter, splitFilterAt);
    });

    return filteredData;
  },

  filterBySearchText(data: Pipeline[], searchText): unknown[] {
    if (!searchText) {
      return data;
    }
    const lowerCaseData = data.map((element) =>
      Object.fromEntries(Object.entries(element).map(([key, value]) => [key, ((value as string) || '').toLowerCase()])),
    );
    return lowerCaseData.map((dataEntry, index) => {
      const filteredElement = Object.values(dataEntry).find((attributeText) =>
        attributeText.includes(searchText.toLowerCase()),
      );
      return filteredElement ? data[index] : null;
    });
  },
};
